<template>
    <navigationComponent />
    <router-view />
</template>

<script>

    // load components
    import navigationComponent from "./global/navigation.vue";

    export default( {
        name: 'app',
        components: {
            navigationComponent
        }
    });

</script>